import { useAtomValue } from 'jotai';
import { UseTemplateFieldsHookType } from './useTemplateFields';
import { editPointOfInterest as editPointOfInterestState } from '../../../state';
import { useCallback, useMemo } from 'react';
import { UNCERTAIN_REASON_FIELD_NAME } from '@/constants';

type Props = {
  dataHook: UseTemplateFieldsHookType;
};

export const useUncertainField = ({ dataHook }: Props) => {
  const editPointOfInterest = useAtomValue(editPointOfInterestState);

  const { handleChange, state } = dataHook;

  const uncertainField = useMemo(() => {
    return editPointOfInterest?.template?.fields.find(
      ({ name }) => name === UNCERTAIN_REASON_FIELD_NAME
    );
  }, [editPointOfInterest?.template?.fields]);

  const uncertainFieldId = uncertainField?.id;

  const fieldValue = useMemo(
    () => (uncertainFieldId ? state[uncertainFieldId] : ''),
    [state, uncertainFieldId]
  );

  const handleUpdateReason = useCallback(
    (value: string) => {
      if (!uncertainFieldId) return;
      handleChange(uncertainFieldId, value);
    },
    [handleChange, uncertainFieldId]
  );

  return { field: uncertainField, fieldValue, handleUpdateReason };
};

export type UncertainFieldHook = ReturnType<typeof useUncertainField>;
